import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithHandlingUnauthorized } from '@ui/src';

const api = createApi({
  reducerPath: 'rootApi',
  baseQuery: baseQueryWithHandlingUnauthorized(process.env.API_HOST as string),
  tagTypes: ['Root'],
  endpoints: () => ({}),
});

export default api;
